import { StyledOffscreenContainer } from './StyledPopover';
import React, { forwardRef, useEffect } from 'react';
import { useForwardedRef } from '@utils/view-layer/react';
import { PopoverProps } from '.';

/* eslint-disable react/display-name */
const PopoverContainer = forwardRef<HTMLDivElement, PopoverProps>(
  (
    {
      children,
      contentRef,
      isFullHeight,
      isFullscreenCentered,
      referenceElement,
      renderMethod,
      onCancel,
      ...rest
    },
    ref
  ) => {
    const _ref = useForwardedRef(ref);

    useEffect(() => {
      const handleDocumentClick = (e: any) => {
        if (e.buttons && e.button && e.button !== 1) {
          return;
        }

        if (
          _ref.current &&
          typeof (_ref.current as any).contains &&
          !(_ref.current as any).contains(e.target)
        ) {
          if (
            referenceElement &&
            !(referenceElement as Element).contains(e.target)
          ) {
            onCancel?.();
          } else if (!referenceElement) {
            onCancel?.();
          }
        }

        if (contentRef && contentRef.current) {
          if (!contentRef.current.contains(e.target)) {
            onCancel?.();
          }
        }
      };

      document.addEventListener('mousedown', handleDocumentClick);

      return () => {
        document.removeEventListener('mousedown', handleDocumentClick);
      };
    }, [_ref, contentRef, referenceElement, onCancel]);

    return (
      <StyledOffscreenContainer
        isFullscreenCentered={isFullscreenCentered}
        ref={_ref}
        renderMethod={renderMethod}
        style={{ height: isFullHeight ? '100%' : undefined }}
        {...rest}
      >
        {children}
      </StyledOffscreenContainer>
    );
  }
);

export default PopoverContainer;
